module.exports = __webpack_public_path__ + "img/outreach.910270e4.png";